import { Confirm } from '../services/Confirm';

const Integrations = {
  mounted () {
    this.load();
  },

  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      config: {
        token: '',
      },
      integration: {
        id: null,
        name: null,
      },
      integrations: [
        //
      ],
      loading: true,
      updating: false,
      success: true,
    };
  },

  computed: {
    disabled () {
      return this.config.token.length < 1 && ! this.integration.id;
    },

    tokenPlaceholder () {
      if (this.integration.id) {
        return 'Deixe em branco para não alterar';
      }
    },
  },

  methods: {
    load () {
      this.loading = true;

      const multiple = this.config.multiple || 0;

      this.$http.get(`/integration/config/${this.integration.name}?multiple=${multiple}`)
        .then((response) => {
          const { config } = response.data;

          if (Array.isArray(response.data)) {
            this.integrations = response.data;
          }

          if (config && config.token) {
            this.config = config;
            this.config.token = ''; // Hide token bc it's encrypted
            this.integration.id = response.data.id;
            this.success = config.success || false;
            this.updating = false;
          }
        })
        .finally((response) => {
          this.loading = false;
        });
    },

    save () {
      this.loading = true;

      if (this.integration.id) {
        this.update(this.config);
      } else {
        this.create(this.config);
      }
    },

    create (config) {
      this.$http.post(`/integration/config/${this.integration.name}`, { config })
        .then(() => {
          this.load();

          this.reset();

          if (this.config.multiple) {
            Alert.info('Configuração adicionada!');
          } else {
            Alert.info('Configurações salvas!');
          }
        })
        .catch((error) => {
          this.loading = false;

          Alert.error('Erro ao adicionar integração!');
        });
    },

    update (config) {
      this.$http.put(`/integration/config/${this.integration.id}`, { config })
        .then(() => {
          this.load();

          Alert.info('Configurações salvas!');
        })
        .catch((error) => {
          this.loading = false;

          Alert.error('Erro ao atualizar integração!');
        });
    },

    async remove () {
      if (! await Confirm(this.__('Deseja mesmo excluir esta integração?'))) {
        return;
      }

      this.$http.delete(`/integration/config/${this.integration.id}`)
        .then(() => {
          this.integration.id = null;

          Alert.info('Integração removida!');
        });
    },

    reset () {
      //
    },
  },
};

export default Integrations;
